'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Ripple = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  0% {\n    opacity: 0;\n    transform: scale(', ');\n  }\n\n  40% {\n    opacity: .18;\n  }\n\n  100% {\n    opacity: 0;\n    transform: scale(', ');\n  }\n'], ['\n  0% {\n    opacity: 0;\n    transform: scale(', ');\n  }\n\n  40% {\n    opacity: .18;\n  }\n\n  100% {\n    opacity: 0;\n    transform: scale(', ');\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-delay: ', 'ms;\n  animation-duration: ', 'ms;\n  animation-fill-mode: forwards;\n  animation-iteration-count: ', ';\n  animation-name: ', ';\n  background-color: ', ';\n  border: 1px solid ', ';\n  border-radius: 50%;\n  display: block;\n  height: 100%;\n  opacity: 0;\n  pointer-events: none;\n  position: absolute;\n  z-index: 2;\n  width: 100%;\n'], ['\n  animation-delay: ', 'ms;\n  animation-duration: ', 'ms;\n  animation-fill-mode: forwards;\n  animation-iteration-count: ', ';\n  animation-name: ', ';\n  background-color: ', ';\n  border: 1px solid ', ';\n  border-radius: 50%;\n  display: block;\n  height: 100%;\n  opacity: 0;\n  pointer-events: none;\n  position: absolute;\n  z-index: 2;\n  width: 100%;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _helpers = require('../../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var animation = function animation(props) {
  return (0, _styledComponents.keyframes)(_templateObject, props.scaleInitial, props.scaleFinal);
};

var Ripple = exports.Ripple = _styledComponents2.default.div(_templateObject2, function (props) {
  return props.animationDelay;
}, function (props) {
  return props.animationDuration;
}, function (props) {
  return props.animationIterationCount;
}, function (props) {
  return props.playing && animation(props);
}, function (props) {
  return props.theme.color[props.variant];
}, function (props) {
  return (0, _helpers.darkenColor)(props.theme.color[props.variant], 8);
});
Ripple.displayName = 'Ripple';


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-ripple/styles.js
// module id = 3032
// module chunks = 4